/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBillingInvoicesResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type BillingInvoicesResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type WithInvoiceItemRequestBuilder, WithInvoiceItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/invoices
 */
export interface InvoicesRequestBuilder extends BaseRequestBuilder<InvoicesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.organizations.subscriptions.invoices.item collection
     * @param invoiceId Unique identifier of the item
     * @returns {WithInvoiceItemRequestBuilder}
     */
     byInvoiceId(invoiceId: string) : WithInvoiceItemRequestBuilder;
    /**
     * Invoices this organization has been billed for its subscription, newest first. Distinct from /api/invoices, which is the organization invoicing its own customers for orders.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BillingInvoicesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BillingInvoicesResponse | undefined>;
    /**
     * Invoices this organization has been billed for its subscription, newest first. Distinct from /api/invoices, which is the organization invoicing its own customers for orders.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InvoicesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/invoices";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const InvoicesRequestBuilderNavigationMetadata: Record<Exclude<keyof InvoicesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byInvoiceId: {
        navigationMetadata: WithInvoiceItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["invoiceId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const InvoicesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvoicesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBillingInvoicesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
